import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';

@Injectable({
  providedIn: 'root'
})
export class IsAdminService {

  constructor(
    private dataService: DataService,
  ) { }

  ifIsAdmin(role: string): void {
    if (role === 'admin') {
      this.dataService.isAdmin$.next(true);
    } else {
      this.dataService.isAdmin$.next(false);
    }
  }
}
